import React from 'react';
import ReactDOM from 'react-dom';

import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

import createHistory from 'history/createHashHistory';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import store from './store';

export const history = createHistory();
// const store = store;

const rootEl = document.getElementById('app-site');

// Create a reusable render method that we can call more than once
let render = () => {
    // Dynamically import our main App component, and render it
    const App = require('./containers/App').default;

    ReactDOM.render(
        <Provider store={store}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ConnectedRouter history={history}>
                    <Switch>
                        <Route path="/" component={App} />
                    </Switch>
                </ConnectedRouter>
            </MuiPickersUtilsProvider>
        </Provider>,
        rootEl
    );
};

if (module.hot) {
    // Support hot reloading of components.
    // Whenever the App component file or one of its dependencies
    // is changed, re-import the updated component and re-render it
    module.hot.accept('./containers/App', () => {
        setTimeout(render);
    });
}
render();



// WEBPACK FOOTER //
// ./index.js